import { css } from '@emotion/core';
import { colors } from 'styles';

export const timeDelimeter = css`
  color: ${colors.lightGrey};
`;
